import React, { createContext, useContext, useMemo, useState, useCallback, useEffect } from "react";
import "../assets/styles/Toast.css";

const ToastContext = createContext();

let idSeq = 1;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((toast) => {
    const id = idSeq++;
    const ttl = typeof toast.duration === "number" ? toast.duration : 5000;
    const entry = { id, type: toast.type || "info", title: toast.title, message: toast.message, duration: ttl };
    setToasts((prev) => [...prev, entry]);
    if (ttl > 0) {
      setTimeout(() => removeToast(id), ttl);
    }
    return id;
  }, [removeToast]);

  const toast = useMemo(() => ({
    info: (message, opts = {}) => addToast({ ...opts, type: "info", message }),
    success: (message, opts = {}) => addToast({ ...opts, type: "success", message }),
    error: (message, opts = {}) => addToast({ ...opts, type: "error", message }),
    warn: (message, opts = {}) => addToast({ ...opts, type: "warning", message }),
  }), [addToast]);

  const value = useMemo(() => ({ toasts, addToast, removeToast, toast }), [toasts, addToast, removeToast, toast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-container" role="status" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast-item ${t.type}`}>
            {t.title && <div className="toast-title">{t.title}</div>}
            {t.message && <div className="toast-message">{t.message}</div>}
            <button className="toast-close" onClick={() => removeToast(t.id)} aria-label="Fechar">×</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast deve ser usado dentro de ToastProvider");
  return ctx;
};

export default ToastContext;
